export const isBlockedEmailDomain = (email: string) => {
  const emailDomain = email.split('@')[1];
  if (EMAIL_DOMAIN_BLOCK_LIST.find(domain => emailDomain.toLowerCase().startsWith(domain)))
    return true;
  return false;
};

const EMAIL_DOMAIN_BLOCK_LIST = [
  'gmail.',
  'googlemail.',
  'yahoo.',
  'hotmail.',
  'icloud.',
  'aol.',
  'msn.',
  'mail.',
  'inbox.',
  'yandex.',
  'globepredict.',
  'thepharmaceuticalsnews.',
  'healthnetworkguide.',
  'zionmarketresearch.',
  'crystalmarketresearch.',
  'reliable-mail.',
  'protonmail.',
  'esiix.',
  'web.',
  'gmx.',
  'me.',
  'example.',
  'egiuz.fodiscomail.',
  'outlook.',
  'otto321.bizml.',
  '﻿﻿2.twowebmail.',
  'edu.ucl.',
  'ideaj.fodiscomail.',
  'enaux.fodiscomail.',
  'bumss.',
  'list.',
  'rambler.ru',
];
